/**
 * Created by idea on 03/07/2017.
 */
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {adminComponent} from './layout/layouts/admin.component';
import {blankComponent} from './layout/layouts/blank.component';

import {LoginComponent} from './pages/admin/auth/login.component';
import {LinkAccountComponent} from './pages/admin/auth/link-account.component';
import {LogoutComponent} from './pages/admin/auth/logout.component';
import {AuthGuard} from './common/services/Auth.guard';

import {EvsProductListComponent} from './pages/admin/evs/product/product_list.component';
import {EvsProductAddComponent} from './pages/admin/evs/product/product_add.component';
import {EvsProductEditComponent} from './pages/admin/evs/product/product_edit.component';
import {EvsProductViewComponent} from './pages/admin/evs/product/product_view.component';
import {LogScanComponent} from './pages/admin/evs/logs/log_scan.component';

import {StoreListComponent} from './pages/admin/evs/store_manager/store_list.component';
import {StoreAddComponent} from './pages/admin/evs/store_manager/store_add.component';
import {StoreEditComponent} from './pages/admin/evs/store_manager/store_edit.component';

// Tuanba:15/03/2022
import {StoreSaleComponent} from './pages/admin/evs/store_manager/store-sale/store-sale.component';
import {StoreSaleAddComponent} from './pages/admin/evs/store_manager/store-sale/store-sale_add.component';
import {StoreSaleEditComponent} from './pages/admin/evs/store_manager/store-sale/store-sale_edit.component';


import {StaffListComponent} from './pages/admin/evs/business/staff-list.component';
import {OwnerListComponent} from './pages/admin/evs/business/owner-list.component';
import {StampActiveForReleaseComponent} from './pages/admin/evs/stamp/stamp-active-for-release.component';
import {LogStampActiveReleaseComponent} from './pages/admin/evs/stamp/log-stamp-active-release.component';
// QR Code
import {ScanStampComponent} from './pages/admin/evs/scan/scan_stamp.component';
import {ActiveGuaranteeComponent} from './pages/admin/evs/guarantee/active-guarantee.component';
import {LogsGuaranteeComponent} from './pages/admin/evs/guarantee/logs-guarantee.component';
import {StampDistributionComponent} from './pages/admin/evs/stamp/stamp-distribution.component';
import {BusinessProfileComponent} from './pages/admin/evs/business/business-profile.component';
import {SettingComponent} from './pages/admin/evs/business/setting.component';
import {BusinessContactComponent} from './pages/admin/evs/business/business-contact/business-contact.component'
import {ChangePasswordComponent} from './pages/admin/evs/business/change-password.component';
import {StampEvsDashboardComponent} from './pages/admin/evs/statistics/stamp-evs-dashboard.component';
import {ForgotPasswordComponent} from './pages/admin/auth/forgot-password.component';
import {Page401Component} from './pages/admin/evs/page-error/page-401-component';
import {RegisterComponent} from './pages/admin/auth/register.component';
import {CancelStampComponent} from './pages/admin/evs/stamp/cancel-stamp.component';
import {FindStampBySerialComponent} from './pages/admin/evs/stamp_list/find-stamp-by-serial.component';
// import { FindStampMbBySerialComponent } from "./pages/admin/evs/stamp_list_mb/find-stamp-mb-by-serial.component";
import {WidthdrawalComponent} from './pages/admin/qrcode/widthdrawal/widthdrawal/widthdrawal.component';
import {DistributionComponent} from './pages/admin/qrcode/distribution/distribution.component';
import {OrderComponent} from './pages/admin/qrcode/order/order/order.component';
import {NotificationsComponent} from './pages/admin/qrcode/notifications/notifications/notifications.component';

import {MapComponent} from './pages/admin/qrcode/batchstamp/map/map.component';
import {GuaranteeAddComponent} from './pages/admin/evs/guarantee/guarantee-add.component';
import {GuaranteeSettingComponent} from './pages/admin/evs/guarantee/guarantee-setting/guarantee-setting.component';
import {PrintComponent} from './pages/admin/evs/guarantee/print/print.component';
import {StaticComponent} from './pages/admin/qrcode/static_stamp/static.component';
import {GiftComponent} from './pages/admin/qrcode/gift/gift.component';
import {ExchangeComponent} from './pages/admin/qrcode/exchange_gift/exchange.component';
import {LoginBusinessComponent} from './pages/admin/auth/business/login-business.component';
import {StaticReportComponent} from './pages/admin/qrcode/static_report/static_report.component';
import {Distribution2Component} from './pages/admin/qrcode/distribution-2/distribution-2.component';
import {FindStampMbBySerialComponent} from './pages/admin/evs/stamp_list_mb/find-stamp-mb-by-serial.component';
import {Log_identifierComponent} from './pages/admin/evs/identifier/log_identifier.component';
import {HistoryActiveComponent} from './pages/admin/qrcode/batchstamp/historyActive/historyActive.component';
import {HistorySaleoutComponent} from './pages/admin/qrcode/batchstamp/history-saleout/historySaleout.component';
import {LinkSaleoutComponent} from './pages/admin/qrcode/batchstamp/linkSaleout/linkSaleout.component';
import {IntegrateSelloutComponent} from './pages/admin/qrcode/integrate-sellout/integrate-sellout.component';
import {IntegrateLoyaltyComponent} from './pages/admin/qrcode/integrate-loyalty/integrate-loyalty.component';
import {LinkLoyaltyComponent} from './pages/admin/qrcode/batchstamp/linkLoyalty/linkLoyalty.component';
import {PrintGuaranteeComponent} from './pages/admin/evs/guarantee/print-guarantee/print-guarantee.component';
import {TrainingComponent} from './pages/admin/qrcode/training/training.component';
// tslint:disable-next-line:comment-format
//Tuanba: 30-12-2022: Tuanba đăng ký tài khoản icheck.
import {RegisterIcheckComponent} from './pages/admin/auth/register-icheck/register-icheck.component';
import {IntegrateLoyaltyComponentV2} from './pages/admin/qrcode/integrate-loyalty-v2/integrate-loyalty-v2.component';
import {ResetPasswordLoginComponent} from './pages/admin/auth/reset-password-login.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {path: '', redirectTo: '/evs/dashboard', pathMatch: 'full'},
      {
        path: '',
        component: adminComponent,
        children: [
          //chuongnv
          {
            path: 'evs/staff/list',
            component: StaffListComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/owner/list',
            component: OwnerListComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/business/profile',
            component: BusinessProfileComponent,
            canActivate: [AuthGuard],
          },
          /** Tuanba: 3/8/2022: setting header **/

          {
            path: 'evs/business/setting',
            component: SettingComponent,
            canActivate: [AuthGuard],
          },
          /** Tuanba: 3/8/2022: End setting header **/
          {
            path: 'evs/business/contact',
            component: BusinessContactComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/business/password',
            component: ChangePasswordComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/stamp/active-for-release',
            component: StampActiveForReleaseComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/stamp/cancel-stamp',
            component: CancelStampComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/stamp/active-for-release/:order_id',
            component: StampActiveForReleaseComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/stamp/log-active',
            component: LogStampActiveReleaseComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/dashboard',
            component: StampEvsDashboardComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/guarantee/active',
            component: ActiveGuaranteeComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/guarantee/logs',
            component: LogsGuaranteeComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/guarantee/add',
            component: GuaranteeAddComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/guarantee/setting',
            component: GuaranteeSettingComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/stamp/distribution',
            component: StampDistributionComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'page-401',
            component: Page401Component,
            canActivate: [AuthGuard],
          },
          {
            path: 'find-stamp',
            component: FindStampBySerialComponent,
            canActivate: [AuthGuard],
          },
          //chuongnv-end

          {
            path: 'evs/product',
            component: EvsProductListComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/product/add',
            component: EvsProductAddComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/product/edit/:id',
            component: EvsProductEditComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/product/view/:id',
            component: EvsProductViewComponent,
            canActivate: [AuthGuard],
          },

          {
            path: 'evs/log-scan',
            component: LogScanComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/identifier',
            component: Log_identifierComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/store-list',
            component: StoreListComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/store-add',
            component: StoreAddComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/store-edit/:id',
            component: StoreEditComponent,
            canActivate: [AuthGuard],
          },
          // tuanBA 14/03/2022: Cấu hình điểm bán
          {
            path: 'evs/store-sale',
            component: StoreSaleComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/store-sale-add',
            component: StoreSaleAddComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/store-sale-edit/:id',
            component: StoreSaleEditComponent,
            canActivate: [AuthGuard],
          },

          // Anph QR Code
          {
            path: 'qrcode/batchstamp',
            loadChildren:
              './pages/admin/qrcode/batchstamp/batchstamp.module#BatchstampModule',
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/mapping',
            component: MapComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/customer',
            loadChildren:
              './pages/admin/qrcode/customer/customer.module#CustomerModule',
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/statistic',
            loadChildren:
              './pages/admin/qrcode/statistic/statistic.module#StatisticModule',
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/withdrawal',
            component: WidthdrawalComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/distribution',
            component: DistributionComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/order',
            component: OrderComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/notifications',
            component: NotificationsComponent,
            canActivate: [AuthGuard],
          },

          {
            path: 'evs/static-stamps',
            component: StaticComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'evs/static-report',
            component: StaticReportComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'promotion/gifts',
            component: GiftComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'promotion/exchange-logs',
            component: ExchangeComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/distribution_2',
            component: Distribution2Component,
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/history-box',
            loadChildren:
              './pages/admin/qrcode/history-box/history-box.module#HistoryBoxModule',
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/agencyListing',
            loadChildren:
              './pages/admin/qrcode/agencyListing/agencyListing.module#AgencyListingModule',
          },
          {
            path: 'qrcode/warning',
            redirectTo: '/evs/dashboard',
            pathMatch: 'full'
          },
          {
            path: 'qrcode/warning-overflow',
            loadChildren:
              './pages/admin/qrcode/warning-overflow/warning-overflow.module#WarningOverflowModule',
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/request-box',
            loadChildren:
              './pages/admin/qrcode/requestBox/requestBox.module#RequestBoxModule',
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/request-box-send',
            loadChildren:
              './pages/admin/qrcode/requestBoxSend/requestBoxSend.module#RequestBoxSendModule',
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/product-roadmap',
            loadChildren:
              './pages/admin/qrcode/productRoadmap/productRoadmap.module#ProductRoadmapModule',
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/seller-import',
            loadChildren:
              './pages/admin/qrcode/sellerImport/sellerImport.module#SellerImportModule',
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/integrate-sellout',
            component: IntegrateSelloutComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/integrate-loyalty',
            component: IntegrateLoyaltyComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/batchstamp/list/history-active/:id',
            component: HistoryActiveComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/batchstamp/list/history-saleout/:id',
            component: HistorySaleoutComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/link-sellout',
            component: LinkSaleoutComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'qrcode/link-loyalty',
            component: LinkLoyaltyComponent,
            canActivate: [AuthGuard],
          },
          /** TuanHA: 2/1/2023: Guide */
          {
            path: 'qrcode/training',
            component: TrainingComponent,
            canActivate: [AuthGuard],
          },
          /** TuanBA: 2/1/2023: Tích hợp loyalty bản mới */
          {
            path: 'qrcode/integrate-loyalty-v2',
            component: IntegrateLoyaltyComponentV2,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: '',
        component: blankComponent,
        children: [
          {path: 'login', component: LoginComponent},
          {path: 'logout', component: LogoutComponent},
          {path: 'register', component: RegisterComponent},
          {path: 'forgot-password', component: ForgotPasswordComponent},
          {path: 'redirect-login', component: LoginBusinessComponent},
          {path: 'link-account', component: LinkAccountComponent},
          /**Tuanba: 30-12-2022: Tuanba đăng ký tài khoản icheck**/
          {path: 'register-icheck', component: RegisterIcheckComponent},
          /**Tuanba: 7-1-2024: Tuanba Sửa luồng login**/
          {path: 'reset-password-login', component: ResetPasswordLoginComponent},
        ],
      },
      {
        path: '',
        component: blankComponent,
        children: [
          {path: 'evs/scan-stamp-qrm/:qrm', component: ScanStampComponent},
          {
            path: 'evs/scan-stamp-code-id/:code_id',
            component: ScanStampComponent,
          },
        ],
      },
      {
        path: '',
        component: blankComponent,
        children: [{path: 'print', component: PrintComponent}],
      },
      {
        path: '',
        component: blankComponent,
        children: [{path: 'print-guarantee', component: PrintGuaranteeComponent}],
      },
      {
        path: 'find-stamp/mb',
        // loadChildren:
        //   "./pages/admin/qrcode/history-box/history-box.module#HistoryBoxModule",
        component: FindStampMbBySerialComponent,
        // canActivate: [AuthGuard],
      },
    ]),
  ],
  exports: [RouterModule],
})
export class AppAdminRoutingModule {
}



// WEBPACK FOOTER //
// /app/src/app/app-admin.routes.ts